'use strict';

(function () {
    const elements = document.querySelectorAll('.truncated')

    if (!elements.length) {
        return false;
    }

    let counter = 0;

    elements.forEach(element => {
        const button = document.createElement('button');

        button.setAttribute('class', 'btn btn--link content-panel__btn js-toggle');
        button.setAttribute('data-toggle-label', 'Read Less');
        button.setAttribute('data-toggle', '#truncated-' + counter);
        button.textContent = 'Read More';

        element.setAttribute('id', 'truncated-' + counter);

        element.parentNode.insertBefore(button, element.nextSibling);

        counter++;
    });
}());
